module.exports = __webpack_public_path__ + "static/img/home-item8.4e26c34.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home-item8.png
// module id = arZ1
// module chunks = 21